import { render, staticRenderFns } from "./RichTable.vue?vue&type=template&id=1a4faee8&scoped=true&"
import script from "./RichTable.vue?vue&type=script&lang=js&"
export * from "./RichTable.vue?vue&type=script&lang=js&"
import style0 from "./RichTable.vue?vue&type=style&index=0&id=1a4faee8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4faee8",
  null
  
)

export default component.exports